import { HTTP } from "../../../http-common";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "@/models/httpError";

const state = {};
const getters = {
  getField
};
const mutations = {
  updateField
};
const actions = {
  getSupportingData({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("qantas/GetSupportingData")
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject();
        });
    });
  },
  validateABN({ dispatch }, abn) {
    return new Promise((resolve, reject) => {
      HTTP.get("TotalCheck/ValidateABN/" + abn)
        .then(data => {
          if (data.data.results.length >= 1) {
            resolve(data.data.results[0]);
          } else {
            resolve({
              abn_status: "false"
            });
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject({
            abn_status: "false"
          });
        });
    });
  },
  checkEnrollment({}, request) {
    return new Promise((resolve, reject) => {
      if (request.ubAccountNo == undefined) {
        request.ubAccountNo = 0;
      }

      HTTP.post(`qantas/SOGQantasEnrollment/${request.ubAccountNo}`, request)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.response.data);
        });
    });
  },
  checkRegistration({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      HTTP.post("qantas/CheckRegistration", request)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "orders/setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject({
            abn_status: "false",
            message: err.response.data
          });
        });
    });
  },
  listCustomers({ rootState }, includeNonContract) {
    return new Promise((resolve, reject) => {
      HTTP.get(`Customer/GetQBREligibleDealerCustomers/${includeNonContract}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  existingQBRCustomers({}) {
    return new Promise((resolve, reject) => {
      HTTP.get(`Customer/GetCurrentQBRCustomers`)
        .then(data => {
          resolve(data.data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  listSalesforceLeads({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("Qantas/GetApprovedLeads")
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "orders/setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
        });
    });
  },
  listFailedQantasPoints({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("Qantas/GetFailedQantasData")
          .then(data => {
            resolve(data.data);
          })
          .catch(err => {
            dispatch(
                "setMessage",
                new httpError({
                  message: err.message,
                  httpStatus: 500
                }),
                {
                  root: true
                }
            );
            reject();
          });
    });
  },
  updateCompanyABN({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      HTTP.post('Qantas/UpdateCompanyABN/' + request.custNo + '/' + request.abn + '/' + request.id)
          .then(data => {
            resolve(data.data);
          })
          .catch(err => {
            dispatch(
                "setMessage",
                new httpError({
                  message: err.message,
                  httpStatus: 500
                }),
                {
                  root: true
                }
            );
            reject();
          });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
